const text_61 = {
  intervention: 61,
  description_short: "Verken je gewoontes rond middelen- en schermgebruik en vind een gezondere balans.",
  step_2_title: "",
  description_part1: "",
  description_part2: "",
  description_part3: "",
}

export {text_61};
